(() => {
  const field = document.getElementById('delivery_date');
  if (!field || !window.flatpickr) return;
  const error = document.getElementById('delivery_error');
  const today = () => {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-AU', {timeZone:'Australia/Melbourne',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(new Date()).map(p=>[p.type,p.value]));
    const date = new Date(Number(parts.year), Number(parts.month)-1, Number(parts.day));
    if (Number(parts.hour) >= 16) date.setDate(date.getDate()+1);
    return date;
  };
  const picker = flatpickr(field, {dateFormat:'d-m-Y',minDate:today(),disableMobile:true,onOpen:(_,__,instance)=>instance.set('minDate',today()),onChange:()=>{if(error)error.style.display='none';}});
  function valid() {
    const selected=picker.parseDate(field.value,'d-m-Y');
    const okay=!!selected && selected >= today();
    if(error)error.style.display=okay?'none':'block';
    if(!okay){field.focus();picker.open();}
    return okay;
  }
  document.addEventListener('submit',e=>{if(e.target.id==='cart' && !valid())e.preventDefault();},true);
  document.addEventListener('click',e=>{if(e.target.closest('[name="checkout"]') && !valid()){e.preventDefault();e.stopImmediatePropagation();}},true);
})();